export default __webpack_public_path__ + "static/media/gd.a6f54338.svg";